import { render, staticRenderFns } from "./dataLive.vue?vue&type=template&id=01f596be&scoped=true&"
import script from "./dataLive.vue?vue&type=script&lang=js&"
export * from "./dataLive.vue?vue&type=script&lang=js&"
import style0 from "./dataLive.vue?vue&type=style&index=0&id=01f596be&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f596be",
  null
  
)

export default component.exports